module.exports = __webpack_public_path__ + "static/media/money-bill-wave-alt.da2bc69c.svg";